<script lang="ts">
	import type { HTMLImgAttributes } from 'svelte/elements';
	import { imageBuilder, type ImageFormat } from '../imageBuilder';
	import { checkVisibility } from '$lib/actions/checkVisibility';

	interface Props extends Omit<HTMLImgAttributes, 'sizes'> {
		width?: number;
		height?: number;
		sizes?: Record<number, { width?: number; height?: number }>;
		wrapperClass?: string;
		priority?: HTMLImgAttributes['fetchpriority'];
		format?: ImageFormat;
	}

	let {
		src,
		alt = '',
		title = '',
		loading = 'lazy',
		width = 0,
		height = 0,
		sizes = {},
		wrapperClass,
		priority,
		style,
		class: className,
		format,
		...other
	}: Props = $props();

	let sortedSizes = $derived(Object.keys(sizes).sort((a, b) => Number(b) - Number(a)));
</script>

{#if src}
	{@const imgBuilder = imageBuilder(src)}
	<picture
		class={wrapperClass}
		{style}
		use:checkVisibility={{ once: true }}
		onvisible={({ detail }) => {
			if (detail && loading === 'lazy') {
				loading = 'eager';
			}
		}}
	>
		{#each sortedSizes as minWidth}
			{@const { width = 0, height = 0 } = sizes[+minWidth]}

			<source
				media="(min-width: {minWidth}px)"
				srcset={`${imgBuilder.size(width, height).format(format).url()} ${minWidth}w`}
			/>
		{/each}
		<img
			src={imgBuilder.size(width, height).format(format).url()}
			{alt}
			{title}
			{loading}
			class={className}
			fetchpriority={priority}
			width={width || undefined}
			height={height || undefined}
			{...other}
		/>
	</picture>
{/if}

<style>
	picture {
		content-visibility: auto;
	}
</style>
